import { LightColor } from '@shure/shared/angular/data-access/system-api/models';

export interface CssFilter {
	invert: number;
	sepia: number;
	saturate: number;
	hueRotate: number;
	brightness: number;
	contrast: number;
}

export const colorToFilter: Record<LightColor, CssFilter> = {
	[LightColor.Red]: { invert: 54, sepia: 61, saturate: 6992, hueRotate: 345, brightness: 102, contrast: 101 },
	[LightColor.Orange]: { invert: 70, sepia: 10, saturate: 4428, hueRotate: 336, brightness: 101, contrast: 101 },
	[LightColor.Gold]: { invert: 78, sepia: 57, saturate: 1963, hueRotate: 1, brightness: 107, contrast: 103 },
	[LightColor.Yellow]: { invert: 92, sepia: 88, saturate: 3092, hueRotate: 328, brightness: 109, contrast: 108 },
	[LightColor.YellowGreen]: { invert: 79, sepia: 96, saturate: 1828, hueRotate: 12, brightness: 102, contrast: 105 },
	[LightColor.Green]: { invert: 82, sepia: 18, saturate: 5171, hueRotate: 58, brightness: 101, contrast: 103 },
	[LightColor.Turquoise]: { invert: 84, sepia: 92, saturate: 7300, hueRotate: 136, brightness: 93, contrast: 88 },
	[LightColor.PowderBlue]: { invert: 86, sepia: 42, saturate: 215, hueRotate: 141, brightness: 96, contrast: 87 },
	[LightColor.Cyan]: { invert: 92, sepia: 100, saturate: 1384, hueRotate: 104, brightness: 106, contrast: 107 },
	[LightColor.SkyBlue]: { invert: 58, sepia: 33, saturate: 6330, hueRotate: 164, brightness: 109, contrast: 102 },
	[LightColor.Blue]: { invert: 39, sepia: 60, saturate: 5578, hueRotate: 213, brightness: 101, contrast: 103 },
	[LightColor.Purple]: { invert: 63, sepia: 40, saturate: 2319, hueRotate: 216, brightness: 102, contrast: 102 },
	[LightColor.LightPurple]: { invert: 66, sepia: 61, saturate: 514, hueRotate: 212, brightness: 98, contrast: 107 },
	[LightColor.Violet]: { invert: 80, sepia: 48, saturate: 2838, hueRotate: 239, brightness: 95, contrast: 95 },
	[LightColor.Orchid]: { invert: 71, sepia: 63, saturate: 2482, hueRotate: 244, brightness: 88, contrast: 93 },
	[LightColor.Pink]: { invert: 66, sepia: 60, saturate: 4617, hueRotate: 296, brightness: 99, contrast: 106 },
	[LightColor.White]: { invert: 100, sepia: 0, saturate: 0, hueRotate: 204, brightness: 104, contrast: 104 }
};
